<div class="filter-options">
  <mat-form-field floatLabel="never">
    <input matInput (keyup)="onFilterInput($event)" #filter [(ngModel)]="filterStr" placeholder="{{ 'call_log.filter' | translate }}" />
    <button mat-icon-button matSuffix (click)="clearFilter()">
      <mat-icon *ngIf="filterStr">clear</mat-icon>
      <mat-icon *ngIf="!filterStr">search</mat-icon>
    </button>
  </mat-form-field>
</div>

<table mat-table [dataSource]="dataSource" matSort>
  <ng-container matColumnDef="time">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'call_log.col_time' | translate }}</th>
    <td mat-cell *matCellDef="let row">{{ row.callStart | timeAndDateFormatter }}</td>
  </ng-container>

  <ng-container matColumnDef="trigger">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let row">
      <mat-icon *ngIf="row.trigger === 2" matTooltip="{{ 'call_log.incoming' | translate }}">call_received</mat-icon>
      <mat-icon *ngIf="row.trigger === 1" matTooltip="{{ 'call_log.outgoing' | translate }}">call_made</mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="caller">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'call_log.col_caller' | translate }}</th>
    <td mat-cell *matCellDef="let row">
      <b>{{ row | nameAndNumber }}</b>
    </td>
  </ng-container>

  <ng-container matColumnDef="duration">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'call_log.col_duration' | translate }}</th>
    <td mat-cell *matCellDef="let row">{{ row.duration | durationFormatter }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="handleRowClick(row)" style="cursor: pointer;"></tr>
</table>

<mat-paginator [length]="callLog.length" [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
